import pmmyImage from "../Assets/Services/service1.jpg";
import pmegpImage from "../Assets/Services/service2.webp";
import womenImage from "../Assets/Services/service3.webp";
import propertyImage from "../Assets/Services/property_loan.jpg";
import weddingImage from "../Assets/Services/wedding_loan.jpg";

const serviceData = [
  {
    slug: "pmmy",
    title: "Pradhan Mantri MUDRA Yojana (PMMY)",
    bigImg: pmmyImage,
    intro:
      "Pradhan Mantri MUDRA Yojana is a Government of India scheme intended to support institutional credit for eligible micro-enterprises. It can cover eligible term-loan and working-capital needs for income-generating activities in manufacturing, trading, services and certain allied agricultural activities. The loan is provided by participating banks and other eligible lending institutions; PyLoan does not provide the loan.",
    sections: [
      {
        heading: "MUDRA categories",
        table: {
          headers: ["Category", "Loan range", "Key note"],
          rows: [
            ["Shishu", "Up to ₹50,000", "For smaller eligible business credit needs."],
            ["Kishor", "Above ₹50,000 up to ₹5 lakh", "For eligible businesses requiring a larger amount."],
            ["Tarun", "Above ₹5 lakh up to ₹10 lakh", "Subject to lender appraisal."],
            ["Tarun Plus", "Above ₹10 lakh up to ₹20 lakh", "For entrepreneurs who previously availed and successfully repaid a Tarun-category loan, subject to current rules."],
          ],
        },
      },
      {
        heading: "How to read the information",
        paragraphs: [
          "Collateral is not required under PMMY according to the official scheme information. Lenders still assess applications, business viability, repayment capacity, credit history and their own applicable rules. Interest rates, tenure, margin and documentation are set according to the lender’s terms; there is no universal rate or automatic approval.",
        ],
      },
      {
        heading: "Who may consider it?",
        paragraphs: [
          "Micro-business owners and prospective entrepreneurs with eligible income-generating business activities may explore PMMY. The participating lender will determine eligibility, permitted activity, amount and repayment conditions. It should not be presented as a personal-consumption loan or a guaranteed entitlement.",
        ],
      },
      {
        heading: "Documents a lender may ask for",
        bullets: [
          "Identity and address proof, such as Aadhaar/PAN or other accepted documents.",
          "Business address and business existence details, where applicable.",
          "Bank statements and financial information relevant to the business.",
          "Project report, cost estimates, quotations or details of the proposed use of funds, where applicable.",
          "Business registration, licences, tax returns or other documents depending on the applicant and lender.",
        ],
        paragraphs: [
          "This is an indicative list, not a universal official checklist. The applicant should obtain the current checklist from the selected participating lender.",
        ],
      },
    ],
    source: {
      label: "Department of Financial Services - PMMY",
      url: "https://financialservices.gov.in/pradhan-mantri-mudra-yojana-pmmy",
    },
  },
  {
    slug: "pmegp",
    title: "Prime Minister’s Employment Generation Programme (PMEGP)",
    bigImg: pmegpImage,
    intro:
      "The Prime Minister’s Employment Generation Programme (PMEGP) is a credit-linked subsidy programme intended to support eligible new micro-enterprises in the non-farm sector and encourage self-employment. KVIC is the national nodal agency; implementation involves agencies such as State KVIC Directorates, KVIBs, District Industries Centres and banks. PyLoan only provides general information and does not process PMEGP applications.",
    sections: [
      {
        heading: "Broad eligibility and project rules",
        bullets: [
          "The official portal states that an individual applicant must be over 18 years of age; there is no income ceiling for setting up a new project under the scheme.",
          "The assistance is for eligible new projects. Existing units or applicants who have already received specified government subsidy support may be ineligible under scheme rules.",
          "For project costs above ₹10 lakh in manufacturing or above ₹5 lakh in business/service, the official portal states that at least an VIII-standard pass educational qualification is required.",
          "Projects must include eligible capital expenditure; projects without capital expenditure are not eligible under the stated rules.",
          "The official scheme guideline sets maximum project costs eligible for margin-money subsidy at ₹50 lakh for manufacturing and ₹20 lakh for business/service. Rules and exclusions apply.",
          "The margin-money subsidy rate varies by applicant category and rural/urban location. It is not a cash grant paid directly in advance to every applicant; it is handled through the scheme and lending bank subject to conditions.",
        ],
      },
      {
        heading: "Own contribution and subsidy",
        paragraphs: [
          "Under the published scheme booklet, general-category beneficiaries typically contribute 10% of project cost and special-category beneficiaries - including women - typically contribute 5%, while margin-money subsidy rates vary by category and location. Confirm current official guidelines before quoting a specific subsidy percentage. The bank appraises the loan and the scheme authority checks eligibility; neither approval nor subsidy should be promised.",
        ],
      },
      {
        heading: "Possible documents",
        bullets: [
          "Aadhaar and PAN or other documents required by the portal or bank.",
          "Project report, project cost estimates and details of machinery, equipment or other capital expenditure.",
          "Educational qualification proof if required for project cost and sector.",
          "Category certificate if claiming a category-based benefit, where applicable.",
          "Business/project location and premises details.",
          "Bank-specific KYC, financial and other documents requested during appraisal.",
        ],
      },
    ],
    source: {
      label: "Official PMEGP portal",
      url: "https://www.kviconline.gov.in/pmegpeportal/pmegphome/index.jsp",
    },
  },
  {
    slug: "stand-up-india",
    title: "Stand-Up India - status and background guide",
    bigImg: womenImage,
    statusNote:
      "The original Stand-Up India scheme period was stated by the Department of Financial Services to run up to 31 March 2025. A March 2026 government news report described a revamped successor proposal. Do not present the old scheme as currently open for new applications unless an official current notification confirms it.",
    intro:
      "Stand-Up India was designed to facilitate bank loans of ₹10 lakh to ₹1 crore for eligible women entrepreneurs and SC/ST entrepreneurs to establish a greenfield enterprise in manufacturing, services, trading or eligible agricultural-allied activities. This page is background information; current availability and application routes must be verified with the official government portal.",
    sections: [
      {
        heading: "What was Stand-Up India?",
        paragraphs: [
          "Under the earlier scheme, applicants generally had to be over 18. For non-individual enterprises, at least 51% shareholding and controlling stake was required to be held by an eligible SC/ST or woman entrepreneur. The earlier repayment framework allowed up to seven years including a moratorium period, subject to lender appraisal and scheme rules.",
          "Because the original scheme period ended on 31 March 2025 and the successor or revamped programme’s current operational rules must be verified, this guide should be treated as scheme background until the official government portal confirms current application availability.",
        ],
      },
      {
        heading: "Before relying on this guide",
        bullets: [
          "Check the current status on the Department of Financial Services website.",
          "Confirm whether any successor programme has been formally notified and what eligibility rules apply.",
          "Do not pay a private intermediary or share sensitive credentials because a website claims to arrange a scheme loan.",
        ],
      },
    ],
    source: {
      label: "Department of Financial Services - Stand-Up India",
      url: "https://financialservices.gov.in/stand-india-scheme-supi",
    },
  },
  {
    slug: "women-entrepreneur-finance",
    title: "Women Entrepreneur Loan Information",
    bigImg: womenImage,
    intro:
      "Women starting or expanding a business may explore different financing routes depending on the purpose, business stage, amount needed, location and eligibility. These are information options, not a guarantee that a particular applicant qualifies.",
    sections: [
      {
        heading: "MUDRA / PMMY",
        paragraphs: [
          "Eligible women running micro-enterprises may explore PMMY through participating lending institutions. The scheme has Shishu, Kishor, Tarun and Tarun Plus categories; Tarun Plus is subject to the previous Tarun loan being successfully repaid and current scheme rules. The lender decides eligibility and terms.",
        ],
      },
      {
        heading: "PMEGP",
        paragraphs: [
          "Women are included among the special categories in PMEGP. For eligible new micro-enterprises, the programme may provide category-based margin-money subsidy subject to official rules, project eligibility, applicant contribution and bank appraisal. Applicants should verify the latest subsidy table and exclusions on the official portal.",
        ],
      },
      {
        heading: "Bank and state-level programmes",
        paragraphs: [
          "Some banks, state governments, self-help group programmes and development institutions may offer products or support for women-led businesses. Availability, interest rates, collateral, contribution, fees and eligibility differ. Readers should check official bank or government sources and avoid relying on social-media claims or unverified agents.",
        ],
      },
      {
        heading: "Before applying, prepare",
        bullets: [
          "A clear business plan and realistic project cost.",
          "An estimate of own contribution, working capital and expected monthly cash flow.",
          "KYC and bank documents required by the selected lender.",
          "Business registration/licences and tax documents where applicable.",
          "Category or scheme-specific evidence, if relevant.",
          "A comparison of the written interest rate, fees, repayment schedule, collateral/security and consequences of late payment.",
        ],
      },
    ],
    source: {
      label: "Department of Financial Services - PMMY",
      url: "https://financialservices.gov.in/pradhan-mantri-mudra-yojana-pmmy",
    },
  },
  {
    slug: "property-loan-information",
    title: "Property Loan Information",
    bigImg: propertyImage,
    intro:
      "Property loans can involve different products, documentation and repayment obligations. This guide explains questions a reader may want to ask a regulated bank or lender; PyLoan does not offer or arrange property loans.",
    sections: [
      {
        heading: "Questions to ask a lender",
        bullets: [
          "What is the total interest rate, processing fee, insurance cost and other charge?",
          "What income, property-title and valuation documents are required?",
          "How is the repayment schedule calculated, and what happens after a missed payment?",
          "What security, collateral, margin or down-payment conditions apply?",
          "Is the written offer consistent with the lender’s official website and sanction documents?",
        ],
      },
      {
        heading: "Verify before sharing documents",
        paragraphs: [
          "Use the bank or lender’s official website and verified branch or customer-care channel. Do not send OTPs, passwords, bank login credentials or full card details to a website or intermediary claiming to arrange a property loan.",
        ],
      },
    ],
  },
  {
    slug: "wedding-expense-finance",
    title: "Wedding Expense Finance: Things to Consider",
    bigImg: weddingImage,
    intro:
      "Borrowing for a wedding can create a long repayment obligation. This guide covers budgeting questions and written terms to review directly with a regulated lender; PyLoan does not offer wedding loans.",
    sections: [
      {
        heading: "Plan the total cost",
        bullets: [
          "Separate essential expenses from optional upgrades and keep an emergency buffer.",
          "Compare the total repayment amount, not only the advertised monthly instalment.",
          "Check the interest rate, processing fee, insurance, late-payment charge and prepayment terms.",
          "Consider whether the repayment fits comfortably with existing household commitments.",
        ],
      },
      {
        heading: "Compare written terms",
        paragraphs: [
          "Ask a regulated lender for the complete written terms and verify the lender’s official contact details. Do not rely on guaranteed-approval claims, social-media advertisements or an agent asking for an upfront fee or sensitive credentials.",
        ],
      },
    ],
  },
];

export default serviceData;
